
export default {
  name: 'Staff',
  components: {},
  data() {
    return {
      host: null
    }
  },
  watch: {
  },
  activated() {

  },
  created() {
    console.log('Staff2222', process.env)
    this.host = process.env.VUE_APP_INTER_BASE_HOST
  },
  mounted() {
  //   console.log('Staff222233', process.env)
  //   this.host = process.env.VUE_INTER_BASE_HOST
  //   console.log('Staff222233444', process.env, this.host)
  },
  computed: {
  },
  methods: {
  }
}
